import React from "react";

export const DisplayWidget = (props) => {
    const {
        primaryText,
        secondaryText,
        background,
        Icon,
        color,
        click,
    } = props;
    return (
        <div
            style={{
                position: "relative",
                background,
                minWidth: "100%",
                minHeight: "60px",
                padding: 0,
                margin: 0,
                boxShadow:
                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                cursor: click ? "pointer" : "inherit",
            }}
            onClick={click}
        >
            <div
                style={{
                    position: "relative",
                    float: "left",
                    background: "rgba(0,0,0,.15)",
                    width: "60px",
                    minHeight: "60px",
                    height: "100%",
                    lineHeight: "100%",
                    color,
                }}
            >
                <Icon
                    style={{
                        textAlign: "center",
                        position: "relative",
                        display: "block",
                        margin: "16 auto",
                    }}
                />
            </div>
            <div
                style={{
                    position: "relative",
                    width: "calc(100% - 60px)",
                    minHeight: "60px",
                    float: "right",
                    margin: 0,
                    padding: 6,
                    color,
                }}
            >
                {primaryText ? primaryText : "N/A"}

                {secondaryText ? secondaryText : "N/A"}
            </div>
        </div>
    );
};
